const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrayAmico(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-2",
    d: "M94.7,444.38C9,394.92,9,314.74,94.7,265.29s224.53-49.46,310.19,0,85.66,129.63,0,179.09S180.36,493.84,94.7,444.38Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M214.43,353.7c-15.15,4.3-30.27,3.95-45.82,3.53-12.13-.34-27.38-1.41-37.94,5.63-3.87,2.58-7.7,6.38-7.49,11s4.27,8.05,8.19,10.51c15,9.38,32.58,13.69,48,22.25,7.37,4.09,14.16,9.1,21.15,13.79,21.19,14.22,42.63,27.76,68,30.6,10.42,1.17,23.84-1.37,32.66-7a41.79,41.79,0,0,0,9.21-8.5c2.32-2.77,4.35-6.2,7-8.61,4.89-4.45,9-6.41,15.62-6.79s15.59-3.62,20.24-8.32a17.15,17.15,0,0,0,3.45-17.43c-4.53-12.29-17.24-20.61-27.47-27.92a126.8,126.8,0,0,0-36.37-18.22c-18.79-5.75-39.24-6.57-58.14-1.17C227.88,349,221.28,351.75,214.43,353.7Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Aura--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--aura--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 242.23,
    cy: 165.9,
    r: 112,
    transform: "translate(-46.36 219.88) rotate(-45)",
    style: {
      fill: "#BA68C8",
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.23,
    cy: 165.9,
    r: 51.26,
    transform: "translate(-45.05 105.33) rotate(-22.5)",
    style: {
      fill: "#BA68C8",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 242.23,
    cy: 165.9,
    r: 78.59,
    transform: "translate(-46.36 219.88) rotate(-45)",
    style: {
      fill: "#BA68C8",
      opacity: 0.07
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leaf--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141,357.51a33,33,0,0,0,3.64-.95c.67-.23,1.33-.53,2-.76a3.11,3.11,0,0,0,1.5-.81.65.65,0,0,0,.17-.41.52.52,0,0,0-.5-.43,1.68,1.68,0,0,0-.69.18,39,39,0,0,1-12.55,2.8c-5.64.42-11.71.11-16.87-2.4-5.58-2.71-7.46-8-6.83-11.77s3.45-6.25,7.53-6.75c9.73-1.21,21.15,4.61,27.75,14.17a.55.55,0,0,0,.75.14.54.54,0,0,0,.13-.75c-6.82-9.88-18.65-15.89-28.77-14.63-4.6.57-7.76,3.43-8.46,7.64-.84,5.08,2.22,10.39,7.43,12.92,4.74,2.3,10.2,2.84,15.4,2.65a55.69,55.69,0,0,0,8-.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.24,353.5a.54.54,0,0,0,.16-1c-10.48-6.09-29.46-11-29.65-11.05a.54.54,0,0,0-.27,1.05c.19.05,19,4.91,29.38,10.93A.52.52,0,0,0,143.24,353.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.3,348.75a.72.72,0,0,0,.2-.09l6-4.36a.53.53,0,0,0,.12-.75.54.54,0,0,0-.75-.12l-6,4.36a.53.53,0,0,0-.12.75A.54.54,0,0,0,114.3,348.75Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.52,352.58a.55.55,0,0,0,.24-.12l6.91-5.82a.55.55,0,0,0,.06-.76.53.53,0,0,0-.76-.06l-6.9,5.82a.54.54,0,0,0-.07.76A.53.53,0,0,0,120.52,352.58Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.25,355.06a.7.7,0,0,0,.23-.11l7-5.86a.54.54,0,0,0-.7-.83l-6.94,5.86a.53.53,0,0,0-.06.76A.52.52,0,0,0,127.25,355.06Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.9,354.82a.66.66,0,0,0,.24-.11l4.15-3.51a.53.53,0,0,0,.07-.75.54.54,0,0,0-.76-.07l-4.15,3.5a.54.54,0,0,0-.07.76A.53.53,0,0,0,134.9,354.82Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,345.54h0a.55.55,0,0,0,.41-.65L123,338.42a.53.53,0,0,0-.63-.41h0a.54.54,0,0,0-.41.64l1.42,6.47A.53.53,0,0,0,124,345.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.12,348h0a.53.53,0,0,0,.39-.65l-1.64-6.65a.52.52,0,0,0-.65-.4.54.54,0,0,0-.39.66l1.64,6.64A.53.53,0,0,0,131.12,348Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.8,350.3h0a.54.54,0,0,0,.41-.64l-1.3-6a.55.55,0,0,0-.64-.42h0a.55.55,0,0,0-.42.65l1.31,6A.54.54,0,0,0,136.8,350.3Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--leaf--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.74,241.89c3.55,0,12.84,1.43,22.52,14.67,17,23.2,10.78,54.86,9.87,59l-5.9,2.65c.3-12.49-1.38-20.28-5.7-26.63-5.11-7.52-12-13.89-17.55-19-2.8-2.59-5.21-4.82-6.93-6.75-8-8.95-9.19-15.89-3.82-21.22a10.5,10.5,0,0,1,7.51-2.75m0-1a11.44,11.44,0,0,0-8.2,3q-8.65,8.59,3.77,22.58c5.23,5.88,16.81,14.5,24.4,25.66,4.68,6.87,5.92,15.5,5.49,27.63l7.78-3.5s8.67-34.88-9.92-60.32c-7.88-10.79-16.64-15.08-23.32-15.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.71,306.32a.58.58,0,0,1-.58-.56c-.5-35.35-36-59.39-36.39-59.62a.57.57,0,0,1-.18-.79.58.58,0,0,1,.79-.17c.36.23,36.42,24.62,36.93,60.56a.57.57,0,0,1-.57.58Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.43,251.93h-.12a.57.57,0,0,1-.44-.68l1.48-7a.57.57,0,0,1,.68-.44.58.58,0,0,1,.44.68l-1.48,7A.57.57,0,0,1,154.43,251.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.73,257.08a.57.57,0,0,1-.55-.41.58.58,0,0,1,.4-.71l9.14-2.57a.58.58,0,0,1,.71.4.57.57,0,0,1-.4.7l-9.14,2.57A.47.47,0,0,1,147.73,257.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.74,258.85l-.16,0a.57.57,0,0,1-.39-.71l2.57-9.12a.58.58,0,0,1,.7-.4.58.58,0,0,1,.4.71l-2.57,9.12A.59.59,0,0,1,161.74,258.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.61,265.56a.57.57,0,0,1-.17-1.12l11.68-3.51a.57.57,0,1,1,.32,1.09l-11.67,3.51A.45.45,0,0,1,152.61,265.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.27,266.35l-.2,0a.58.58,0,0,1-.33-.74l3.73-10a.57.57,0,0,1,1.07.4l-3.73,10A.57.57,0,0,1,168.27,266.35Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.58,270.73a.57.57,0,0,1-.13-1.13L169.08,267a.57.57,0,0,1,.27,1.11l-10.63,2.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.42,272.9a.68.68,0,0,1-.28-.07.58.58,0,0,1-.22-.78l4.34-7.92a.58.58,0,1,1,1,.55l-4.35,7.92A.57.57,0,0,1,173.42,272.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.46,276.72a.57.57,0,0,1-.57-.51.58.58,0,0,1,.51-.63l8.74-.9a.58.58,0,0,1,.63.51.57.57,0,0,1-.51.63l-8.74.9Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.06,280a.59.59,0,0,1-.31-.09.57.57,0,0,1-.17-.79l4.36-6.81a.58.58,0,0,1,.79-.18.57.57,0,0,1,.18.79l-4.37,6.82A.56.56,0,0,1,177.06,280Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.51,283.91h0l-6.29-.13a.56.56,0,0,1-.56-.58.57.57,0,0,1,.57-.56h0l6.29.13a.56.56,0,0,1,.56.58A.57.57,0,0,1,178.51,283.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.68,288.65a.62.62,0,0,1-.34-.11.57.57,0,0,1-.12-.8l3.75-5.13a.57.57,0,1,1,.92.68l-3.75,5.12A.55.55,0,0,1,180.68,288.65Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.82,293.08h0l-4.76-.32a.57.57,0,0,1-.53-.61.55.55,0,0,1,.61-.53l4.75.32a.58.58,0,0,1,0,1.15Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--leaf--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.9,337.19a.58.58,0,0,1-.57-.43c-6.87-28.86,15.5-55.24,18.07-58.15,1.62-1.83,6.83-8.24,6.08-13.9a7.72,7.72,0,0,0-3.69-5.52,12.51,12.51,0,0,0-7.49-2.09c-6,.22-12.48,4.36-18.27,11.65-8.1,10.2-12,32.7-8.24,47.19a82,82,0,0,0,4.43,12.67,23.24,23.24,0,0,0,6.45,8.48,1.91,1.91,0,0,1,.63.73,1.7,1.7,0,0,1-1.29,0,4.14,4.14,0,0,1-1.1-.71,20.78,20.78,0,0,1-5.53-7.61,82.73,82.73,0,0,1-4.68-13.25c-3.93-15.05,0-37.56,8.45-48.18,6-7.56,12.79-11.86,19.11-12.09a13.59,13.59,0,0,1,8.15,2.29,8.81,8.81,0,0,1,4.19,6.31c.82,6.13-4.65,12.88-6.35,14.8-2.54,2.86-24.56,28.84-17.82,57.14a.56.56,0,0,1-.06.42.6.6,0,0,1-.36.26Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.63,337.1c0,.26.16,1.11-.19,1.18s-.69-.53-.81-.74a15.83,15.83,0,0,1-1.28-3.75c-.37-1.14-.72-2.28-1-3.43a92.7,92.7,0,0,1-2.25-9.87c-1.75-10.18-1.89-21,1.52-30.85,5.2-15,18.35-27.25,23.65-29.3a.43.43,0,0,1,.19,0,.54.54,0,0,1,.54.36.56.56,0,0,1-.32.73c-4.52,1.75-17.81,13.61-23,28.61-.35,1-.65,2-.93,3.06-2.54,9.52-2.06,19.69-.18,29.29a92,92,0,0,0,2.57,10.09A26,26,0,0,1,305.63,337.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,268.16h-.11l-10.66-1.57a.57.57,0,0,1-.47-.64.56.56,0,0,1,.53-.48.41.41,0,0,1,.11,0L329.06,267a.55.55,0,0,1,.36.22.5.5,0,0,1,.11.42.56.56,0,0,1-.53.48Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.51,274.12l-11.13-1.27a.58.58,0,0,1-.5-.62.57.57,0,0,1,.54-.5L323.64,273a.56.56,0,0,1,.37.19.59.59,0,0,1,.12.43.57.57,0,0,1-.54.5Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.93,280h-.11l-11.47-1.69a.56.56,0,0,1-.47-.64.56.56,0,0,1,.53-.48h.11L320,278.92a.56.56,0,0,1-.06,1.12Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.46,284.73a.58.58,0,0,1-.53-.6.56.56,0,0,1,.54-.53l12.46.79a.53.53,0,0,1,.39.18.57.57,0,0,1,.14.41.56.56,0,0,1-.54.53Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9,291a.57.57,0,0,1-.54-.59.57.57,0,0,1,.54-.54l11.7.51a.57.57,0,0,1,0,1.13Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.19,298.65a.6.6,0,0,1-.54-.59.57.57,0,0,1,.54-.54l10.53.46a.53.53,0,0,1,.54.58.57.57,0,0,1-.54.54Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.46,304.9h-.12a.56.56,0,0,1,.08-1.11l8.32-.19a.54.54,0,0,1,.39.16.54.54,0,0,1,.18.4.56.56,0,0,1-.54.57Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.62,312.82h-.13a.56.56,0,0,1-.45-.48.57.57,0,0,1,.48-.64l6.47-.9a.58.58,0,0,1,.63.48.57.57,0,0,1-.48.64Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.34,319.3h-.12a.57.57,0,0,1-.44-.42.56.56,0,0,1,.41-.68l5.47-1.38.11,0a.56.56,0,0,1,.57.43.54.54,0,0,1-.06.43.53.53,0,0,1-.35.25l-5.47,1.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,316.48h-.13l-.12,0L294.17,314a.59.59,0,0,1-.3-.3.61.61,0,0,1,0-.44.56.56,0,0,1,.5-.34.69.69,0,0,1,.24.05l5.55,2.42a.57.57,0,0,1,.3.31.57.57,0,0,1-.5.77Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.44,308.45h-.13l-.12,0-5.77-2.57a.57.57,0,0,1-.3-.31.58.58,0,0,1,0-.43.56.56,0,0,1,.75-.29l5.77,2.57a.56.56,0,0,1-.21,1.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.76,301.09a.29.29,0,0,1-.13,0,.44.44,0,0,1-.15-.05l-5.31-2.79a.56.56,0,0,1-.24-.76.55.55,0,0,1,.48-.3.48.48,0,0,1,.28.06L300,300a.57.57,0,0,1,.24.76A.55.55,0,0,1,299.76,301.09Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.18,293.71h-.13a.45.45,0,0,1-.23-.11l-5.24-4a.55.55,0,0,1-.22-.37.57.57,0,0,1,.11-.42.6.6,0,0,1,.43-.22.57.57,0,0,1,.37.12l5.23,4a.56.56,0,0,1,.11.79.59.59,0,0,1-.43.22Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.35,269.43h-.13a.54.54,0,0,1-.4-.3l-3.06-6.2a.56.56,0,0,1,.25-.76.86.86,0,0,1,.23-.06.59.59,0,0,1,.53.32l3.06,6.2a.56.56,0,0,1-.26.75A.46.46,0,0,1,315.35,269.43Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.2,275.53h-.13a.58.58,0,0,1-.39-.28l-4-7.48a.57.57,0,0,1,.23-.76.55.55,0,0,1,.25-.07.58.58,0,0,1,.52.3l4,7.47a.56.56,0,0,1-.23.76A.45.45,0,0,1,310.2,275.53Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.5,281.08h-.13a.52.52,0,0,1-.34-.2l-5.21-6.55a.56.56,0,0,1,.1-.79.47.47,0,0,1,.32-.12.56.56,0,0,1,.47.21l5.21,6.55a.57.57,0,0,1-.09.79A.52.52,0,0,1,306.5,281.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.28,287.42h-.13a.53.53,0,0,1-.31-.17l-5.38-5.79a.56.56,0,0,1-.15-.41.53.53,0,0,1,.18-.39.51.51,0,0,1,.36-.15.55.55,0,0,1,.43.18l5.39,5.79a.61.61,0,0,1,.15.41.57.57,0,0,1-.18.39A.61.61,0,0,1,303.28,287.42Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.77,263.64h-.13a.56.56,0,0,1-.42-.35l-1.46-3.86a.58.58,0,0,1,0-.43.62.62,0,0,1,.32-.3l.18,0a.58.58,0,0,1,.55.36l1.45,3.86a.54.54,0,0,1,0,.43.57.57,0,0,1-.31.3Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--leaf--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.45,353.53a42.5,42.5,0,0,1-31.2,5.83,35.51,35.51,0,0,1-9.58-3.42c-14.14-7.59-9.75-11.78-7.41-13.42s8.59-5.89,10.18-9.71a60.52,60.52,0,0,1-11.36,4.69c-5.73,1.58-6.93,4.33-12.54-2.78s-7.64-19.38-7.64-19.38,9.53,1.09,14.26-2.76c0,0-9.77-1.31-13.08-3.42S118,303.5,117,297.46s-2.88-12.83.3-13.69,11.73-2.78,24,1.87c0,0,5.55,9.8,5.63,16.74,0,0,2.47-8.06-1.07-18.95a33,33,0,0,1,12.43,2.34c6.71,2.63,11.15,5.43,12.51,7.74s3.44,13.44.5,22.76c0,0,5.69-6.19,5.25-14s1.74-6.21,4.94-4.81c2.88,1.26,18.11,20.85,15.31,44.55a15.92,15.92,0,0,1-7.38,11.55Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.45,353.53a42.5,42.5,0,0,1-31.2,5.83,35.51,35.51,0,0,1-9.58-3.42c-14.14-7.59-9.75-11.78-7.41-13.42s8.59-5.89,10.18-9.71a60.52,60.52,0,0,1-11.36,4.69c-5.73,1.58-6.93,4.33-12.54-2.78s-7.64-19.38-7.64-19.38,9.53,1.09,14.26-2.76c0,0-9.77-1.31-13.08-3.42S118,303.5,117,297.46s-2.88-12.83.3-13.69,11.73-2.78,24,1.87c0,0,5.55,9.8,5.63,16.74,0,0,2.47-8.06-1.07-18.95a33,33,0,0,1,12.43,2.34c6.71,2.63,11.15,5.43,12.51,7.74s3.44,13.44.5,22.76c0,0,5.69-6.19,5.25-14s1.74-6.21,4.94-4.81c2.88,1.26,18.11,20.85,15.31,44.55a15.92,15.92,0,0,1-7.38,11.55Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.71,352.45a.49.49,0,0,1-.4-.21c-33.79-50.57-65.69-65.47-66-65.61a.48.48,0,0,1,.39-.87c.32.15,32.46,15.14,66.41,65.95a.47.47,0,0,1-.13.66A.5.5,0,0,1,184.71,352.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.38,327.17a.48.48,0,0,1-.11-.94c.16,0,15.91-3.7,27-10.94a.48.48,0,0,1,.52.8c-11.24,7.33-27.16,11-27.32,11.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.19,349.14a.47.47,0,0,1-.46-.34.48.48,0,0,1,.32-.59c.12,0,12.72-3.94,22.83-11.1a.47.47,0,1,1,.54.78c-10.23,7.24-23,11.19-23.09,11.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.1,300.23A39.49,39.49,0,0,1,121.21,298a.47.47,0,1,1,.33-.89c.09,0,9.24,3.33,15.74,1.68a.46.46,0,0,1,.57.34.48.48,0,0,1-.34.58A18.3,18.3,0,0,1,133.1,300.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.85,321.3l-.15,0a.48.48,0,0,1-.27-.64c6.27-15.07.06-29.89,0-30a.47.47,0,0,1,.26-.64.48.48,0,0,1,.64.25c.07.16,6.44,15.36,0,30.8A.49.49,0,0,1,160.85,321.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,342a.5.5,0,0,1-.26-.08.48.48,0,0,1-.14-.66,39,39,0,0,0,5.67-28.06.47.47,0,1,1,.93-.19,40,40,0,0,1-5.8,28.77A.49.49,0,0,1,178,342Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--leaf--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.24,366.85q-1.55-1.16-3-2.46a25.09,25.09,0,0,1-4.39-5.59,1.12,1.12,0,0,1-.22-.57.42.42,0,0,1,.35-.45.66.66,0,0,1,.41.23,17.28,17.28,0,0,1,1.4,1.77,36.69,36.69,0,0,0,10.67,9.2,44.87,44.87,0,0,0,13.6,5.66,28.06,28.06,0,0,0,6.9.67c7.21-.26,11.69-5,12.8-9.32s-.74-8.27-4.84-10.72c-9.8-5.86-24.68-5-36.19,2.05a.63.63,0,0,1-.86-.2.62.62,0,0,1,.21-.86c11.89-7.31,27.3-8.15,37.48-2.06,4.63,2.77,6.65,7.29,5.41,12.1-1.49,5.8-7.23,10-14,10.26a33.61,33.61,0,0,1-12.65-2.28A49.07,49.07,0,0,1,341,368.8C340.05,368.18,339.13,367.53,338.24,366.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.74,360.2l-.09,0a22.33,22.33,0,0,1-3-1.06A14.53,14.53,0,0,1,332,357.7c-.2-.15-.43-.37-.37-.62a3,3,0,0,1,1.25.29l.86.33a46.65,46.65,0,0,0,14.64,2.82c4.1.1,8.2.39,12.28.78q4.88.46,9.72,1.14c1.35.19,2.7.38,4,.6a.62.62,0,0,1,.51.72.63.63,0,0,1-.72.52l-.64-.11q-3.14-.48-6.29-.87c-3.53-.45-7.08-.82-10.64-1.09-2.53-.2-5.06-.38-7.6-.35a37.08,37.08,0,0,1-7.64-.76C340.16,360.86,338.94,360.56,337.74,360.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.4,370.53a.66.66,0,0,1-.18-.19l-4.39-7.47a.63.63,0,0,1,.22-.86.64.64,0,0,1,.86.22l4.39,7.48a.61.61,0,0,1-.22.85A.62.62,0,0,1,370.4,370.53Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,371.68a.48.48,0,0,1-.19-.23L357.16,362a.63.63,0,0,1,1.13-.55l4.61,9.44a.62.62,0,0,1-.93.78Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.66,371.17a.52.52,0,0,1-.2-.24l-4.64-9.49a.62.62,0,0,1,.29-.83.61.61,0,0,1,.83.28l4.64,9.49a.62.62,0,0,1-.29.84A.6.6,0,0,1,353.66,371.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.62,367.32a.74.74,0,0,1-.2-.23l-2.77-5.68a.63.63,0,1,1,1.13-.55l2.77,5.67a.63.63,0,0,1-.29.84A.61.61,0,0,1,345.62,367.32Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.59,362.56h0a.63.63,0,0,1-.13-.88l4.54-6.22a.62.62,0,0,1,.87-.14h0a.64.64,0,0,1,.14.88l-4.55,6.22A.62.62,0,0,1,361.59,362.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.84,361.85h0a.63.63,0,0,1-.11-.88l4.87-6.3a.6.6,0,0,1,.88-.12.63.63,0,0,1,.11.88l-4.87,6.3A.62.62,0,0,1,352.84,361.85Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.72,361.62h0a.62.62,0,0,1-.14-.87l4.19-5.76a.66.66,0,0,1,.88-.14h0a.62.62,0,0,1,.14.87l-4.2,5.76A.63.63,0,0,1,345.72,361.62Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--leaf--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.87,356.38c8.19,1.08,23.83,6.3,39.37-5.49s22-45.53,18.48-55.92c-2.47-7.26-44.36-5.29-59.49,9.28S298.8,346.13,316.87,356.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.87,356.38c8.19,1.08,23.83,6.3,39.37-5.49s22-45.53,18.48-55.92c-2.47-7.26-44.36-5.29-59.49,9.28S298.8,346.13,316.87,356.38Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.18,350.69A.69.69,0,0,1,313,350c7.43-27.64,38.87-49.94,54.38-54.67a.69.69,0,0,1,.85.46.68.68,0,0,1-.45.84c-15.26,4.65-46.17,26.57-53.47,53.72a.67.67,0,0,1-.83.48A.61.61,0,0,1,313.18,350.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.84,307.28a.67.67,0,0,1-.14-.74.68.68,0,0,1,.89-.36c4.78,2,13.44,3.41,20.1,2.06a.68.68,0,0,1,.8.53.69.69,0,0,1-.53.8c-6.92,1.4-15.93-.05-20.9-2.14A.86.86,0,0,1,346.84,307.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.91,311.58a.64.64,0,0,1-.21-.25c-2.47-5-3.12-9.11-2.1-13.21a.68.68,0,0,1,.82-.49.67.67,0,0,1,.49.82c-.93,3.77-.32,7.55,2,12.28a.69.69,0,0,1-.31.91A.7.7,0,0,1,340.91,311.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.51,317.48a.66.66,0,0,1-.1-.81.67.67,0,0,1,.92-.25c8,4.58,19.94,8.58,29.24,6a.67.67,0,0,1,.83.47.68.68,0,0,1-.48.84c-8.23,2.25-19.54-.06-30.26-6.17A.61.61,0,0,1,334.51,317.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.1,325.16a.59.59,0,0,1-.2-.24c-3.6-7.06-5.44-13.28-5.78-19.55a.68.68,0,0,1,.64-.71.69.69,0,0,1,.72.64c.33,6.07,2.12,12.11,5.62,19a.69.69,0,0,1-.29.92A.69.69,0,0,1,327.1,325.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.94,332.19a.69.69,0,0,1-.1-.81.67.67,0,0,1,.93-.25c11.05,6.31,21.65,8.8,33.35,7.84a.66.66,0,0,1,.73.62.67.67,0,0,1-.62.73c-11.82,1-23-1.65-34.14-8Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sparkles--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shine--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M374.54,200a.76.76,0,0,1-.35-1l.29-.68a3.86,3.86,0,0,0-1.52-4.84l-.63-.4a.77.77,0,0,1,.71-1.35l.68.29h0a3.87,3.87,0,0,0,4.85-1.52l.39-.63a.76.76,0,0,1,1-.27h0a.76.76,0,0,1,.35,1l-.29.68a3.88,3.88,0,0,0,1.52,4.85l.63.39a.77.77,0,0,1-.71,1.35l-.68-.29a3.87,3.87,0,0,0-4.84,1.52l-.4.63a.76.76,0,0,1-1,.27Zm.95-6.11a5.45,5.45,0,0,1,.84,2.68,5.45,5.45,0,0,1,2.68-.84,5.42,5.42,0,0,1-.84-2.68A5.42,5.42,0,0,1,375.49,193.9Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.8,197.76a.4.4,0,0,1-.43-.34L75.3,197a2.07,2.07,0,0,0-2.07-1.74h-.4a.41.41,0,0,1-.41-.38.4.4,0,0,1,.34-.43l.39-.07h0a2.07,2.07,0,0,0,1.74-2.07V192a.41.41,0,0,1,.37-.41h0a.41.41,0,0,1,.44.34l.06.39A2.07,2.07,0,0,0,77.84,194h.39a.41.41,0,0,1,.07.81l-.39.06A2.07,2.07,0,0,0,76.17,197v.39a.41.41,0,0,1-.37.41Zm-1.32-3a2.89,2.89,0,0,1,1.14,1,2.92,2.92,0,0,1,1-1.15,2.82,2.82,0,0,1-1.15-1A2.79,2.79,0,0,1,74.48,194.74Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.92,253.65a.62.62,0,0,1-.67-.52l-.1-.59A3.13,3.13,0,0,0,98,249.9H97.4a.62.62,0,0,1-.1-1.24l.59-.09h0a3.14,3.14,0,0,0,2.64-3.15v-.6a.63.63,0,0,1,.57-.63h0a.62.62,0,0,1,.66.52l.1.59A3.14,3.14,0,0,0,105,248h.6a.61.61,0,0,1,.62.57.61.61,0,0,1-.51.66l-.6.1a3.14,3.14,0,0,0-2.64,3.14v.6a.62.62,0,0,1-.56.63Zm-2-4.58a4.25,4.25,0,0,1,1.74,1.46,4.41,4.41,0,0,1,1.46-1.74,4.41,4.41,0,0,1-1.74-1.46A4.33,4.33,0,0,1,99.9,249.07Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.47,217.41a2.74,2.74,0,1,1,3.57-1.49A2.73,2.73,0,0,1,99.47,217.41Zm1.76-4.27a1.88,1.88,0,1,0,1,2.46A1.9,1.9,0,0,0,101.23,213.14Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.07,242.5a2.74,2.74,0,1,1,3.81.67A2.73,2.73,0,0,1,359.07,242.5Zm3.78-2.65a1.88,1.88,0,1,0-.46,2.62A1.88,1.88,0,0,0,362.85,239.85Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.11,187.18a2.73,2.73,0,1,1,3.81.67A2.73,2.73,0,0,1,398.11,187.18Zm3.78-2.65a1.89,1.89,0,1,0-.46,2.63A1.89,1.89,0,0,0,401.89,184.53Z",
    style: {
      fill: "#BA68C8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M384.78,218.56a.38.38,0,0,1-.16-.5l.57-1.09a.38.38,0,0,1,.5-.16.37.37,0,0,1,.15.5l-.57,1.09A.36.36,0,0,1,384.78,218.56Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.78,218.87l-1.09-.58a.35.35,0,0,1-.15-.49.38.38,0,0,1,.5-.16l1.09.57a.37.37,0,0,1,.15.5A.38.38,0,0,1,383.78,218.87Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.49,221a.38.38,0,0,1-.16-.5l.58-1.09a.35.35,0,0,1,.49-.15.38.38,0,0,1,.16.5l-.57,1.09A.37.37,0,0,1,383.49,221Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.24,220.15l-1.09-.57a.36.36,0,0,1-.15-.5.35.35,0,0,1,.49-.15l1.09.57a.38.38,0,0,1,.16.5A.37.37,0,0,1,386.24,220.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.92,225.68a.37.37,0,0,1-.39-.33l-.1-1.21a.36.36,0,0,1,.72-.06l.1,1.21A.36.36,0,0,1,121.92,225.68Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.26,226.46l-1.2.1a.36.36,0,1,1-.07-.72l1.21-.1a.35.35,0,0,1,.39.33A.36.36,0,0,1,121.26,226.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.16,228.4a.38.38,0,0,1-.4-.33l-.1-1.21a.36.36,0,0,1,.72-.06l.11,1.2A.38.38,0,0,1,122.16,228.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,226.23l-1.2.1a.36.36,0,1,1-.07-.72l1.21-.11a.36.36,0,0,1,.39.33A.37.37,0,0,1,124,226.23Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.1,169.47a.4.4,0,0,1-.17-.53l.6-1.14a.38.38,0,1,1,.68.36l-.59,1.14A.4.4,0,0,1,376.1,169.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.06,169.79l-1.14-.6a.38.38,0,1,1,.35-.68l1.14.6a.38.38,0,1,1-.35.68Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.75,172a.38.38,0,0,1-.16-.52l.59-1.14a.39.39,0,0,1,.69.35l-.6,1.14A.39.39,0,0,1,374.75,172Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.63,171.14l-1.14-.6a.38.38,0,1,1,.36-.68l1.14.59a.39.39,0,0,1-.36.69Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.94,172.81a.74.74,0,0,1-.79-.67l-.2-2.43a.73.73,0,1,1,1.45-.12l.21,2.43A.74.74,0,0,1,99.94,172.81Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.62,174.39l-2.43.21a.73.73,0,0,1-.79-.67.72.72,0,0,1,.66-.79l2.43-.21a.73.73,0,0,1,.13,1.46Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.42,178.29a.73.73,0,0,1-.79-.67l-.21-2.43a.72.72,0,0,1,.66-.79.73.73,0,0,1,.79.67l.21,2.43A.73.73,0,0,1,100.42,178.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.1,173.92l-2.43.2a.73.73,0,1,1-.13-1.45l2.43-.21a.72.72,0,0,1,.79.66A.73.73,0,0,1,104.1,173.92Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.63,394.39s-39.14-14.75-44-18.8c-4-3.38-1.61-11.46-7.21-12.84-6.44-1.59-11,2-15.19,5.89-3.91,3.71-9,5.38-18.69,1.95s-19-8.34-22.87-6.39-1.29,5.07,15.58,13.1c9.7,4.62,22.05,10,30,13.2a65.75,65.75,0,0,1,16,8.91c10.32,7.45,12.22,9,24.43,16.58,24.41,15.07,38.76,19,58.18,15.25Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214,380.41c-7.78,4.48-11.54,9.42-12,18,0,0,5.25,4.07,13.55,9.82,9.95,6.89,34,22.56,50.12,24.2,24.94,2.54,33.48-3.87,33.48-3.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.77,385.24c12.77,22.16,44,35.95,53.75,37-3.46-2.93-8.54-12.87-13.36-23.65L214,379.52A29.16,29.16,0,0,0,206.77,385.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.57,362.35a5.55,5.55,0,0,1,.91-4.6c3.45-4.2,7.85-6.42,10.85-8A23.36,23.36,0,0,1,157,347.52c7.64.47,14.22,6.36,21.87,6.81,5.71.35,10.9-2.65,16.46-4.05a17.28,17.28,0,0,1,5.36-.47c1.52.1,3.94,1.18,4.49,2.53a7,7,0,0,1,.42,5.05c-.34,1.07-2.47,3.09-4,4.2-2.09,1.53-4.69,2-7.8,2.9C186,366.87,150.85,367.72,133.57,362.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.84,373.38c0,.72.12,1.41.2,2.14.1,1-.42,1.28-1.21,1.84-3.22,2.27-7.28,2.05-11,1.39-2.86-.51-5.77-1.34-8.61-.77-3.41.69-6.12,3.26-8.65,5.7a6.63,6.63,0,0,0-1.38,1.86s-19.74-8.69-28.72-13.58c-4.54-2.48-9.79-4.79-13.37-8.71-.2-.21.87-1.59,1-1.72a8.42,8.42,0,0,1,4.54-2.62,22.49,22.49,0,0,1,8.67-.6c4.42.67,8.71,1.87,13.09,2.76a106.39,106.39,0,0,0,11.87,1.72,87.49,87.49,0,0,0,13.05.22,31.44,31.44,0,0,0,11.88-2.59,17.25,17.25,0,0,0,4.08-2.58,12.59,12.59,0,0,0,1.86-2.47c.62-.9,1-2.41,1.61-1.13,1.5,3.06,1.81,7.77,1.6,11.19-.15,2.36-.45,4.7-.53,7.06C206.83,372.8,206.83,373.09,206.84,373.38Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.84,373.38c0,.72.12,1.41.2,2.14.1,1-.42,1.28-1.21,1.84-3.22,2.27-7.28,2.05-11,1.39-2.86-.51-5.77-1.34-8.61-.77-3.41.69-6.12,3.26-8.65,5.7a6.63,6.63,0,0,0-1.38,1.86s-19.74-8.69-28.72-13.58c-4.54-2.48-9.79-4.79-13.37-8.71-.2-.21.87-1.59,1-1.72a8.42,8.42,0,0,1,4.54-2.62,22.49,22.49,0,0,1,8.67-.6c4.42.67,8.71,1.87,13.09,2.76a106.39,106.39,0,0,0,11.87,1.72,87.49,87.49,0,0,0,13.05.22,31.44,31.44,0,0,0,11.88-2.59,17.25,17.25,0,0,0,4.08-2.58,12.59,12.59,0,0,0,1.86-2.47c.62-.9,1-2.41,1.61-1.13,1.5,3.06,1.81,7.77,1.6,11.19-.15,2.36-.45,4.7-.53,7.06C206.83,372.8,206.83,373.09,206.84,373.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.43,359.64c-3.69,5.21-3.67,14.45-3.67,14.45a140.08,140.08,0,0,1-12.56-6.33c-6-3.43-5.63-5.41-5.63-5.41a5.45,5.45,0,0,1,1.74-2.71,10.92,10.92,0,0,1,8-2.48A50.54,50.54,0,0,1,155.43,359.64Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.16,371a11,11,0,0,0-.38,4.58,5.11,5.11,0,0,0,2,.95,19.34,19.34,0,0,1,.48-4.71C157.63,370.48,155.61,369.72,155.16,371Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.16,373.84a10.7,10.7,0,0,0-.41,4.58,5.27,5.27,0,0,0,2,.93,16.34,16.34,0,0,1,.48-4.69C163.63,373.31,161.61,372.56,161.16,373.84Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.16,376.67a10.77,10.77,0,0,0-.38,4.54,4.83,4.83,0,0,0,2,1,19.83,19.83,0,0,1,.48-4.7C169.63,376.15,167.61,375.4,167.16,376.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.77,354.24a3.9,3.9,0,0,0-.59-1.9s-2,4.17-9,6.59c-6.7,2.29-16.26,3.4-30.06.11s-21.78-6.33-28-3.78-4.51,7.09-4.51,7.09,3-5.66,11.73-4.6c8.43,1,20.85,5.63,32.4,6.07C189.76,364.29,202,362.7,205.77,354.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.36,377.5c-3.85-13.74-15.19-23.72-32.26-38-14.48-12.13-41.25-31.77-41.25-31.77h0l-76.26-15.19c-3.1,13.92-13.25,23.74-13.22,43.09,0,14.08,2.21,33.94,26.84,52.22,14.94,11.09,26.85,19.8,37.56,26.6,11.31,7.18,36.86,21.33,51,14.86,10.81-4.94,12.67-14.44,12.29-22.37h0c1.72.17,3.45.26,5.05.27,1.87.06,3.57,0,4.92,0a33.87,33.87,0,0,0,14.62-3.68C343.93,398.79,348.45,388.52,345.36,377.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.13,407.18c-1.6,0-3.35-.11-5.07-.27C307.57,391.52,249.59,347,249.59,347c4-2,13.37-7,16.5-12.59-1.28,7.16-5.39,10.81-9.37,13.71,6.12,5.49,31.86,27.18,38.72,33.7C302.65,388.69,311.64,397.48,315.13,407.18Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.35,207.82c11.09,2.64,15.73,3.69,21.11,10.34,3.75,4.64,16.71,37.24,20.27,52.77,2.4,10.47,2.24,25.33-2.4,28.65-4.94,3.53-14.11-1.19-19.53-5.78-3.93-3.34-5.71-5.55-7.76-7.27Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.68,271.75c3.91-.36,9.58.39,12.82,3.76-1.62-3.07-5.93-5.86-13.28-5.16Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.44,236.72c-6-12.68-12.55-20.52-21.09-29,0,0-11-2.67-18.4-3.87s-11.51-.81-19.27.05c-3.89.42-15.31,3.28-21.34,4.55.56,17.75,3.9,26.82-7.46,40.73-.29,11.05,1.83,33.23,2.1,40.89.22,6.27-9.11,17-12.62,32.44,14.22,15.57,73,19.95,96.75-8.77a83.29,83.29,0,0,0-7.73-12.09c1.08-13.74,1.37-26.94,1.94-30.4C284.49,261.19,287.07,248.66,281.44,236.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.32,128.84s-8.77-1-15,10.45c-7.71,14.2-8.27,29.84-8.08,39.87s3,14.83,8.94,17.86a24.72,24.72,0,0,1-.32-14.26s2.53,14.75,17,18.68,39.81,7.7,47.78-2.38c-3.34-8.43,2-35.83,2-35.83A16.11,16.11,0,0,0,286,149.65c1.1-10.62-5-20.18-13.81-21.45,0,.35-11.51-5.71-11.51-5.71C256.52,117.38,232.28,115.55,223.32,128.84Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.88,161.15c1-13.43,18-38.55,50.34-33,0,0-3.16-3.74-11.51-5.71-11.31-.16-36.28,2-42.31,36.65A9.16,9.16,0,0,1,221.88,161.15Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.36,135.46c3.89,4.36,8.39,13.44,5.46,38.35-2.49,21.11-9.95,25.15-13.43,26.24-2.9.9-8.72.92-13.18-.45l-1.59,8.4s12.73,13.38,2.38,15.61c-20.64,4.44-30.24-18.06-30.24-18.06l3.54-24.7s-5.87,3.08-11.53-3.14c-4.66-5.13-5.64-13.14-1.25-17s11.63-2,13.88,4.28c0,0,10.95,1.57,24.52-4.34C262.09,154.94,268.18,143.41,270.36,135.46Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.44,186.46A1.48,1.48,0,1,1,253,185,1.47,1.47,0,0,1,254.44,186.46Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.21,199.6c-4.41-1-11.07-2.45-16.59-6.38-2.46-1.76-3.91-4.66-5.07-7.95,0,0-.39,5.49,2.87,9.35,4.2,5,18.1,8.52,18.1,8.52Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.08,161.76l1.06,10.05a4.73,4.73,0,0,0,4.35-5.34A5.22,5.22,0,0,0,224.08,161.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.79,165.51c.62.39-.34,3.54-3.91,3.62s-4.64-2.5-3.94-3.08,1.64,1.14,4.2.8C251.93,166.48,252.16,165.12,252.79,165.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.55,166.42c.52.49-1,3.3-4.43,2.67s-3.92-3.29-3.14-3.71,1.33,1.41,3.83,1.6C272.55,167.18,273,165.92,273.55,166.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.22,155.79,243,158a3.45,3.45,0,0,1,2.08-4.31A3.22,3.22,0,0,1,249.22,155.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.07,159.43,269,156.7A3.18,3.18,0,0,1,273.3,155,3.48,3.48,0,0,1,275.07,159.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.15 163.23 257.8 179.48 266.47 177.25 258.15 163.23",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.49,288.84c-1.33-1.17-1.9-1.74-3.44-3.12-2.59-2.33-5.4-3.94-6.25-7.54-1.21-5.12.31-8.28.13-13.3a16,16,0,0,1,.71-6.94s.11-2.79-2.82-9.89c-1.07-2.6-.87-4.76,1.12-5.34-1-3.62.6-4.92,2.34-4.83-.83-2.82-1.31-5.38,1.46-6.59.29-.12,1,.74,1.9,2.75.05-1.89,2.15-3.89,3.07-2.53,4.08,7,4.58,7.31,7.72,13.73,2.68,5.49,3,7.88,3.51,18,.15,2.72-.17,8.92,5.44,12.26",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.43,245.24a32.11,32.11,0,0,1,1.82,3.67,22.47,22.47,0,0,1,1.15,4,62.28,62.28,0,0,1,.88,8.15c.2,2.72,0,5.46.67,8a10.89,10.89,0,0,0,4.43,6.46,10.06,10.06,0,0,1-3.19-2.58,11.41,11.41,0,0,1-1.92-3.69,18,18,0,0,1-.68-4.1c-.07-1.37-.14-2.71-.23-4.07-.15-2.71-.29-5.42-.65-8.09A30.65,30.65,0,0,0,280.43,245.24Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.55,267c-.16-3-.12-3.8-1.34-6.84,0,0-.35-2.78,1.91-10.11.83-2.7.44-4.83-1.6-5.22.66-3.69-1-4.85-2.77-4.6.57-2.88.82-5.48-2.06-6.43-.29-.09-.93.83-1.64,2.92a3.61,3.61,0,0,0-1.42-2.36,12.36,12.36,0,0,0,.65,3.48c-1.74-.09-3.33,1.21-2.34,4.83-2,.58-2.19,2.74-1.12,5.34,2.93,7.1,2.82,9.89,2.82,9.89a16,16,0,0,0-.71,6.94c.18,5-1.34,8.18-.13,13.3a11.37,11.37,0,0,0,6.21,7.61l1.77,1.51a14.8,14.8,0,0,0,3.43-6.42C277.42,275.26,274.83,272.06,274.55,267Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.34,208.45c-14.73,3.37-20.86,9.15-20.86,27.47,0,12.51,9.12,51,16,68.88,3.43,9,8.18,13.13,22.33,9.51,11.47-2.93,45.81-20,50.38-25.21S255.7,275,250.29,277.42s-30.45,7.26-30.45,7.26L211.45,243S212.81,218,201.34,208.45Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.33,293.35c7.94-4.45,10.95-8.87,11.74-12.49,1.22-5.62-1.38-8.82-1.65-13.84-.17-3-.13-3.8-1.35-6.84,0,0-.35-2.78,1.91-10.11.83-2.7.44-4.82-1.6-5.22.66-3.69-1.05-4.84-2.77-4.6.57-2.88.82-5.47-2.06-6.42-.29-.1-.93.82-1.64,2.91-.21-1.88-2.49-3.68-3.28-2.24-3.43,7.34-3.9,7.69-6.44,14.37-2.17,5.71-2.24,8.12-1.85,18.26.1,2.72,1.8,7.57-4.05,10.29",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.89,246.72a58.89,58.89,0,0,0-3.08,9.43c-.27,1.8-.67,5.68-.67,5.68a23.2,23.2,0,0,1,0-6C267.54,251.94,270.89,246.72,270.89,246.72Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.17,240.47c-1.21,3.1-3.77,7.45-4.3,9.73a60.66,60.66,0,0,0-1.2,10.5,26.18,26.18,0,0,1,.53-10.84C265.19,246.32,267,244.47,269.17,240.47Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.91,236.74c-1.78,4.21-4.65,10.11-5.25,11.85s-1.21,10.3-1.21,10.3a47.89,47.89,0,0,1,0-9C260,246.72,265.91,236.74,265.91,236.74Z",
    style: {
      fill: "#f0997a"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrayAmico);
export default __webpack_public_path__ + "static/media/Pray-amico.c64e83a2b21667a916af41eddaa8348f.svg";
export { ForwardRef as ReactComponent };